import { boolean, object, string } from 'yup';
import { ICashItem } from './ICashItem';

export interface IBookingAccount {
  id: string;
  name: string;
  fibu: string;
  inactive: boolean;
  cashItems?: ICashItem[];
}

export interface IBookingAccountInput {
  name: string;
  fibu: string;
  inactive?: boolean;
}

export const IBookingAccountInputSchema = object({
  name: string().required(),
  fibu: string().required(),
  inactive: boolean().optional(),
});
